<div *ngIf="questionCount > 0"
     class="question-status-grid mb-4 p-3 rounded-lg bg-base-200"
     data-testid="question-status-grid">
  <div class="flex items-center justify-between mb-2">
    <span class="text-sm font-semibold">Review your answers</span>
    <span class="text-xs"
          [class.text-success]="allAnswered"
          [class.text-base-content]="!allAnswered"
          data-testid="question-status-grid-summary">
      {{ answeredCount }} of {{ questionCount }} answered
    </span>
  </div>

  <div class="flex flex-wrap gap-2" role="list" aria-label="Question answer status">
    <button *ngFor="let i of cells; trackBy: trackByIndex"
            type="button"
            role="listitem"
            class="badge badge-lg gap-1 cursor-pointer border"
            [class.badge-success]="isAnswered(i)"
            [class.badge-ghost]="!isAnswered(i)"
            [class.text-success-content]="isAnswered(i)"
            [attr.aria-label]="'Question ' + (i + 1) + (isAnswered(i) ? ' answered' : ' not answered') + '. Jump to question.'"
            (click)="onCellClick(i)"
            [attr.data-testid]="'question-status-cell-' + i">
      <app-icon *ngIf="isAnswered(i)" name="check" size="xs"></app-icon>
      <span class="cell-number">{{ i + 1 }}</span>
    </button>
  </div>
</div>
